import React from "react";
import styles from "../../styles/common/skipButton.module.css";

const SkipQuestionare = () => {
  const skipToPreview = () => {
    window.location.href = "/preview";
  };
  return (
    <>
      <button className={styles.skip_button} onClick={skipToPreview}>
        Skip To Preview
      </button>
    </>
  );
};

export default SkipQuestionare;
